'use strict';exports.__esModule = true;var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _reactIdSwiper = require('react-id-swiper');var _reactIdSwiper2 = _interopRequireDefault(_reactIdSwiper);
var _constants = require('./constants');





var _LandingLogosCarousel = require('./LandingLogosCarousel.scss');var styles = _interopRequireWildcard(_LandingLogosCarousel);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

var LogosCarousel = function LogosCarousel() {return (
        _react2.default.createElement('div', { className: styles.containerSlider },
            _react2.default.createElement(_reactIdSwiper2.default, _constants.SETTINGS,
                _constants.TOP_LOGOS.map(function (item) {return (
                        _react2.default.createElement('div', null,
                            _react2.default.createElement('div', { className: styles.logoWrapper },
                                _react2.default.createElement('img', { src: item, alt: 'realtor' }))));})),




            _react2.default.createElement('div', { className: styles.line }),
            _react2.default.createElement(_reactIdSwiper2.default, _constants.SETTINGS,
                _constants.BOTTOM_LOGOS.map(function (item) {return (
                        _react2.default.createElement('div', null,
                            _react2.default.createElement('div', { className: styles.logoWrapper },
                                _react2.default.createElement('img', { src: item, alt: 'realtor' }))));}))));};exports.default =







LogosCarousel;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/LandingLogosCarousel/LandingLogosCarousel.js
// module id = 2702
// module chunks = 0